<template>
    <div class="product-item">
        <img :src="src" alt="Product Image" class="image">
        <span class="title">{{title}}</span>
        <span class="content">{{content}}</span>
    </div>
</template>

<script>
export default {
  name: 'ProductAdvantages',
  props: {
    src: String,
    title: String,
    content: String
  }
}
</script>

<style lang="scss" scoped>

    .product-item{
        width: 250px;
        height: 170px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding:20px;
        .title{
            font-weight: 600;
            margin-bottom: 1rem;
            margin-top: 0.5rem;
            font-size: 1rem;
            color: rgba(55, 69, 103, 1);

        }
       .content{
            text-align: center;
            color:#7A8BA6 ;
            margin-bottom: 1rem;
            font-size: 1rem;
        }
        .image{
            width: 66px;
            height: auto;
        }
    }
</style>
